import ptBrTranslations from './pt-br.json'
import enUsTranslations from './en-us.json'
import esTranslations from './es.json'

export default {
  'pt-BR': ptBrTranslations,  // Atente-se a usar as abreviaturas corretas
  'en-US': enUsTranslations,   // https://support.mozilla.org/pt-BR/kb/abreviacao-de-localizacao
  'es' : esTranslations
}